const runtimeConfigKey1 = 'apiURL';
const runtimeConfigKey4 = 'identityServiceAuthorityUrl';
const runtimeConfigKey3 = 'relativeBasePath';
const runtimeConfigKey5 = 'identityServiceClientId';
const runtimeConfigKey6 = 'cesAppId';
const runtimeConfigKey8 = 'lookupAppId';
const runtimeConfigKey9 = 'b2cDomainHost';
const runtimeConfigKey10 = 'docsAppId';
const runtimeConfigKey11 = 'googleAnalyticsId';

export interface RuntimeEnvironment {
  [runtimeConfigKey1]: string;
  [runtimeConfigKey3]: string;
  [runtimeConfigKey4]: string;
  [runtimeConfigKey5]: string;
  [runtimeConfigKey6]: string;
  [runtimeConfigKey8]: string;
  [runtimeConfigKey9]: string;
  [runtimeConfigKey10]: string;
  [runtimeConfigKey11]: string;
}

const validateStringProperty = (object: { [key: string]: unknown; [key: number]: unknown }, property: string) => {
  if (!Object.keys(object).includes(property)) throw Error();
  if (typeof object[property] !== 'string') throw Error();
};

const validateRuntimeEnvironment = (unvalidatedResponse: any) => {
  if (typeof unvalidatedResponse !== 'object') throw Error();
  if (unvalidatedResponse === null) throw Error();

  validateStringProperty(unvalidatedResponse, runtimeConfigKey1);
  validateStringProperty(unvalidatedResponse, runtimeConfigKey3);
  validateStringProperty(unvalidatedResponse, runtimeConfigKey4);
  validateStringProperty(unvalidatedResponse, runtimeConfigKey5);
  validateStringProperty(unvalidatedResponse, runtimeConfigKey6);
  validateStringProperty(unvalidatedResponse, runtimeConfigKey8);
  validateStringProperty(unvalidatedResponse, runtimeConfigKey9);
  validateStringProperty(unvalidatedResponse, runtimeConfigKey10);
  validateStringProperty(unvalidatedResponse, runtimeConfigKey11);

  return unvalidatedResponse as RuntimeEnvironment;
};

export const getRuntimeEnvironment = async () => {
  const environmentFilePath = 'runtime-environment.json';
  const response = await fetch(`${process.env.PUBLIC_URL}/${environmentFilePath}`);

  if (!response.ok) throw new Error();

  const jsonResponse = (await response.json()) as unknown;

  return validateRuntimeEnvironment(jsonResponse);
};
